import { instance } from '@/services/avik-api-gateway'
import { DailyReportEvent } from '@/types/daily-report-event'
import { AxiosResponse } from 'axios'

export function updateDailyReportEvent(
  body: Partial<DailyReportEvent>
): Promise<AxiosResponse<DailyReportEvent>> {
  return instance.put(`/daily-report/event/${body.uuid}`, body)
}
